module.exports = __webpack_public_path__ + "static/img/fazhan1.4816e637.png";